export default "__VITE_ASSET__d73f8480__"